import { graphql } from '../../graphql/generated';

export const UPDATE_SYSTEM_STATUS_MUTATION = graphql(`
  mutation UpdateSystemStatus($input: SystemStatusInput!) {
    updateSystemStatus(input: $input) {
      id
    }
  }
`);

export const SYSTEM_STATUS_QUERY = graphql(`
  query SystemStatus {
    systemStatus {
      id
      active
      heading
      content
      link
      type
    }
  }
`);
